
import SkeletonTitle from '../../components/skeleton/Title.vue';
import SkeletonListHead from './components/skeleton/ListHead.vue';
import SkeletonList from './components/skeleton/List.vue';
import FrameService from '../../src/FrameService';
import PageSearch from '../../components/Search/PageSearch.vue';
import SortComponent from '../../components/Sort/index.vue';
import Description from '../../components/Description/index.vue';
import Paginate from '../../../../../vue/Paginator/index.vue';
import { Sort } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';
import { mapState } from 'vuex';
import { State } from 'modules/spravochnik/dt-front-page-generator/store';
import { UrlService } from 'modules/spravochnik/dt-front-page-generator/src/Service/Url/UrlService';

export default {
    components: {
        SkeletonTitle,
        SkeletonListHead,
        SkeletonList,
        PageSearch,
        SortComponent,
        Description,
        Paginate,
    },
    props: {
        categoryUrlName: {
            type: String,
            required: true,
        },
    },
    computed: mapState({
        category: (state: State) => state.category.category,
    }),
    created() {
        (new FrameService()).onFooter();
        (new FrameService()).off();
    },
    methods: {
        async onApplySort(value: Sort) {
            this.sort = value;
            this.category.sortMode = value;

            new UrlService(this.$router, this.category).apply();
        },
        onClickLink() {
            this.activeLink = !this.activeLink;
        },
        async changePage(page) {
            this.page = page;
            await this.$store.dispatch('page/loadPageItems', this.page);
        },
    },
    async mounted() {
        document.querySelector('body').style.overflow = 'auto';
        this.loading = true;
        await this.$store.dispatch('category/loadCategory', this.categoryUrlName);
        new UrlService(this.$router, this.category).updateEntity().apply();
        this.total = this.category.countPages;
        this.loading = false;

        // SEO
        if (this.category.seo.metaTitle){
            document.title = this.category.seo.metaTitle;
        } else {
            document.title = this.category.name.name;
        }

        if (this.category.seo.metaDescription){
            document.querySelector('meta[name="description"]').setAttribute("content", this.category.seo.metaDescription);
        } else {
            document.querySelector('meta[name="description"]').setAttribute("content", this.category.name.name);
        }

        if (this.category.seo.metaImage){
            document.querySelector('meta[property="og:image"]').setAttribute("content", this.category.seo.metaImage.url);
        }


    },
    data() {
        return {
            loading: true,
            activeLink: false,
            total: null,
            count: 20,
            page: 1,
            key: 1,
        };
    },
};
